import * as React from 'react';
import { SVGProps } from 'react';

const IconHealthSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-2-12V5h4v5h5v4h-5v5h-4v-5H5v-4h5z"
    />
  </svg>
);
export default IconHealthSizeM;
